import { isEmptyJsonObject } from "../../common/utils/helper";

export const alwaysTrue=()=>{
    return {
        valid:true,
        message:""
      }
}


export const objectTypeNameAndImportSourceMustNotBeEmpty = (currentData,jiraAssetData) => {

  let status = true;
  let message = "";

  if (jiraAssetData.objectTypeName === "") {
    status = false;
    message = "Object Type Name cannot be empty";
  }
  if (isEmptyJsonObject(jiraAssetData.selectedAssetSchema)) {
    status = false;
    message = "One Asset Schema needs to be selected";
  }
  if (jiraAssetData.importSourceName === "") {
    status = false;
    message = "Import Source Name cannot be empty";
  }

  return {
    valid: status,
    message: message,
  };
};
